import {
    CREATE_YEAR_MASTER_FAILURE,
    CREATE_YEAR_MASTER_REQUEST,
    CREATE_YEAR_MASTER_SUCCESS,
    CREATE_USER_FORM_YEAR_MASTER,
    FETCH_YEAR_MASTER_FAILURE,
    FETCH_YEAR_MASTER_REQUEST,
    FETCH_YEAR_MASTER_SUCCESS,
    FETCH_SINGLE_YEAR_MASTER_FAILURE,
    FETCH_SINGLE_YEAR_MASTER_REQUEST,
    FETCH_SINGLE_YEAR_MASTER_SUCCESS,
    YEAR_MASTER_USERFORM_RESET,
    UPDATE_YEAR_MASTER_REQUEST,
    UPDATE_YEAR_MASTER_SUCCESS,
    UPDATE_YEAR_MASTER_FAILURE,
    DELETE_YEAR_MASTER_REQUEST,
    DELETE_YEAR_MASTER_SUCCESS,
    DELETE_YEAR_MASTER_FAILURE
} from './yearMaster.actionsType';

export const YEAR_MASTER = 'yearMaster';

let initialState = {
    loading: false,
    yearMaster: [],
    userform: {},
    selectedYear: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let yearMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;
    switch (type) {
        case FETCH_YEAR_MASTER_REQUEST:
        case CREATE_YEAR_MASTER_REQUEST:
        case FETCH_SINGLE_YEAR_MASTER_REQUEST:
        case UPDATE_YEAR_MASTER_REQUEST:
        case DELETE_YEAR_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_YEAR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                yearMaster: updatePayload
            };

        case CREATE_YEAR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_YEAR_MASTER_SUCCESS:
            return {
                ...state,
                selectedYear: updatePayload,
                loading: false,
                userform: {
                    ...updatePayload,
                    fldFromDate: updatePayload.fldFromDate.split('T')[0],
                    fldToDate: updatePayload.fldToDate.split('T')[0]
                }
            };
        case UPDATE_YEAR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedYear: {}
            };
        case DELETE_YEAR_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_YEAR_MASTER_FAILURE:
        case CREATE_YEAR_MASTER_FAILURE:
        case FETCH_SINGLE_YEAR_MASTER_FAILURE:
        case UPDATE_YEAR_MASTER_FAILURE:
        case DELETE_YEAR_MASTER_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_YEAR_MASTER:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case YEAR_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {}
            };
        default:
            return state;
    }
};
